module.exports = "/_next/static/images/logo-shadow-d1282ce09ac2e0ebbf2ef2c3add0d68f.svg";